// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { Layout } from './Layout';

export default Layout;
